import { MessageCircle, Mail, Phone, MoreHorizontal } from "lucide-react";
import { MenuOrSheet } from "@/components/ActionSheet";
import { fmtPhone } from "@/lib/format";
import { twilio, openMsgs } from "@/lib/whatsapp";

// Telemóvel português como «912 345 678»; estrangeiro com indicativo.
export const showPhone = (s) => (fmtPhone(s) || "").replace(/ /g, "\u00a0");
export const waHref = (s) => {
  const d = String(s || "").replace(/\D/g, "");
  return `https://wa.me/${d.length === 9 ? `351${d}` : d}`;
};

const box = "grid place-items-center w-10 h-10 rounded-xl border border-slate-200 text-ec-green hover:bg-slate-50 transition-colors";
const add = "text-sm font-medium text-ec-green hover:underline";

function Ic({ onClick, href, target, title, testid, children }) {
  return href
    ? <a className={box} href={href} target={target} rel={target ? "noreferrer" : undefined} title={title} aria-label={title} data-testid={testid}>{children}</a>
    : <button type="button" className={box} onClick={onClick} title={title} aria-label={title} data-testid={testid}>{children}</button>;
}

// Uma pessoa nos Contactos: nome, papel e os botões (o número e o email ficam no título de cada botão).
export function PersonLine({ testid, title, role, phone, email, onWa, onMail, onAddPhone, onAddEmail, more = [], extra }) {
  return (
    <div className="py-3 border-t border-slate-100 first:border-t-0" data-testid={testid}>
      <div className="text-[15px] font-semibold navy-text flex flex-wrap items-center gap-1.5">{title}</div>
      {(role || (!phone && onAddPhone) || (!email && onAddEmail)) && <div className="text-sm text-slate-500 flex flex-wrap gap-x-3" data-testid={`${testid}-sub`}>
        {role && <span>{role}</span>}
        {!phone && onAddPhone && <button type="button" onClick={onAddPhone} className={add} data-testid={`${testid}-add-phone`}>+ Adicionar telefone</button>}
        {!email && onAddEmail && <button type="button" onClick={onAddEmail} className={add} data-testid={`${testid}-add-email`}>+ Adicionar email</button>}
      </div>}
      {extra}
      {(phone || email || more.length > 0) && (
        <div className="flex flex-wrap gap-1.5 mt-2">
          {phone && <Ic onClick={onWa || (twilio.on ? () => openMsgs() : undefined)} href={onWa || twilio.on ? undefined : waHref(phone)} target="_blank" title={`WhatsApp · ${showPhone(phone)}`} testid={`${testid}-wa`}><MessageCircle size={16} /></Ic>}
          {phone && <Ic href={`tel:${phone.replace(/[^\d+]/g, "")}`} title={`Ligar · ${showPhone(phone)}`} testid={`${testid}-call`}><Phone size={16} /></Ic>}
          {email && <Ic onClick={onMail} href={onMail ? undefined : `mailto:${email}`} title={`Email · ${email}`} testid={`${testid}-mail`}><Mail size={16} /></Ic>}
          {more.length > 0 && <MenuOrSheet title="Mais" align="start" testid={`${testid}-more-menu`}
            trigger={<button type="button" className={box} aria-label="Mais" data-testid={`${testid}-more`}><MoreHorizontal size={16} /></button>} items={more} />}
        </div>
      )}
    </div>
  );
}
